import { CONTACT_PHONE_DISPLAY, WHATSAPP_URL } from '../data/contact';

const FOOTER_LINKS = [
  { href: '#home', label: 'Inicio' },
  { href: '#about', label: 'Nosotros' },
  { href: '#team', label: 'Equipo' },
  { href: '#blog', label: 'Blog' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer" id="footer">
      <div className="container site-footer__grid">
        <div className="site-footer__block">
          <h2 className="site-footer__title">Sustento Jurídico</h2>
          <p className="site-footer__text">
            Carrera 43B # 16-80, oficina 204
            <br />
            Edificio Delta, Medellín
          </p>
          <p className="site-footer__text">
            Tel: (604) 581 3939
            <br />
            Cel:{' '}
            <a className="site-footer__link" href={WHATSAPP_URL} target="_blank" rel="noreferrer">
              {CONTACT_PHONE_DISPLAY}
            </a>
          </p>
          <a className="site-footer__link" href="mailto:notificaciones@sustentojuridico.com.co">
            notificaciones@sustentojuridico.com.co
          </a>
        </div>

        <div className="site-footer__block">
          <h3 className="site-footer__subtitle">Menú</h3>
          <ul className="site-footer__list">
            {FOOTER_LINKS.map((link) => (
              <li key={link.href}>
                <a href={link.href}>{link.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="site-footer__block">
          <h3 className="site-footer__subtitle">Redes</h3>
          <ul className="site-footer__list">
            <li>
              <a href="https://www.instagram.com/sustentojuridicosas/" target="_blank" rel="noreferrer">
                Instagram
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/sustento.juridico.94" target="_blank" rel="noreferrer">
                Facebook
              </a>
            </li>
            <li>
              <a href="https://twitter.com/sustentojuridi1" target="_blank" rel="noreferrer">
                Twitter / X
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="site-footer__bottom">
        <div className="container site-footer__bottom-inner">
          <p>© {year} Sustento Jurídico. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
